import React from "react";

function CustService() {
  return <div>Customer Service Page</div>;
}

export default CustService;
